<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="30"
      height="30"
      rx="15"
      fill="white"
    />
    <path
      d="M17.0001 9.66663H21.0001C21.7365 9.66663 22.3334 10.2636 22.3334 11V19C22.3334 19.7363 21.7365 20.3333 21.0001 20.3333H9.00008C8.2637 20.3333 7.66675 19.7363 7.66675 19V11C7.66675 10.2636 8.2637 9.66663 9.00008 9.66663H13.0001"
      stroke="#040325"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.66675 13.6666H13.0001M22.3334 13.6666H17.0001"
      stroke="#040325"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.6 8C15.6 7.66863 15.3314 7.4 15 7.4C14.6686 7.4 14.4 7.66863 14.4 8H15.6ZM14.5757 19.4243C14.8101 19.6586 15.1899 19.6586 15.4243 19.4243L19.2426 15.6059C19.477 15.3716 19.477 14.9917 19.2426 14.7574C19.0083 14.523 18.6284 14.523 18.3941 14.7574L15 18.1515L11.6059 14.7574C11.3716 14.523 10.9917 14.523 10.7574 14.7574C10.523 14.9917 10.523 15.3716 10.7574 15.6059L14.5757 19.4243ZM14.4 8V19H15.6V8H14.4Z"
      fill="#040325"
    />
  </svg>
</template>
